import axios from '@/libraries/axios/main';
import User from '@/models/User';
import ApiResponseOld from '@/interfaces/ApiResponseOld';

export async function fetchImportedSessions(): Promise<ApiResponseOld> {
  const response = await axios.get(`/session/`);

  return response.data;
}

export async function importSession(
  uuid: string,
): Promise<{ token: string; user: User } | null> {
  const response = await axios.get(`/session/import/${uuid}`);

  return response.data;
}

export async function deleteImportedSession(
  id: number,
): Promise<{ status: string, message: string }> {
  const response = await axios.delete(`/session/delete/${id}`);

  return response.data as { status: string; message: string };
}
